import { render, staticRenderFns } from "./blacklist-summary.vue?vue&type=template&id=7fba5662&scoped=true&"
import script from "./blacklist-summary.vue?vue&type=script&lang=js&"
export * from "./blacklist-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fba5662",
  null
  
)

export default component.exports